var React = require('react');

var Address = require('../../util/Address');
var Button = require('react-bootstrap').Button;
var BillingActions = require('../../actions/BillingActions');
var BillingGroupStore = require('../../stores/BillingGroupStore');
var CardForm = require('../Payment/CardForm');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var DateRange = require('../../util/DateRange');
var Loading = require('../Loading');
var PaymentTokenStore = require('../../stores/PaymentTokenStore');
var ServiceActions = require('../../actions/ServiceActions');
var TokenActions = require('../../actions/TokenActions');
var TokenSelector = require('../Payment/TokenSelector');
var UserStore = require('../../stores/UserStore');

function getState(billingGroupId) {
    return {
        card: PaymentTokenStore.getNewCard(),
        cardErrors: PaymentTokenStore.getNewCardErrors(),
        group: BillingGroupStore.getById(billingGroupId),
        groupLoading: BillingGroupStore.loading(),
        tokens: PaymentTokenStore.get() || [],
        tokensLoading: PaymentTokenStore.loading(),
        working: PaymentTokenStore.loading(),
    }
}

var BillingGroupView = React.createClass({
    componentDidMount: function() {
        BillingGroupStore.addChangeListener(this.update);
        ClientStore.addChangeListener(this.update);
        PaymentTokenStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        ServiceActions.getServices();
    },
    componentWillUnmount: function () {
        BillingGroupStore.removeChangeListener(this.update);
        ClientStore.removeChangeListener(this.update);
        PaymentTokenStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        var state = getState(this.props.params.billingGroupId);
        state.showNew = false;

        return state;
    },
    handleCardSave: function (e) {
        e.preventDefault();

        TokenActions.save((token) => {
            BillingActions.updateToken(this.state.group, token);
            this.setState({ showNew: false });
        });
    },
    render: function () {
        const group = this.state.group;
        const payments = this.renderPayments(group);

        var content;
        if (group) {
            content = (<div>
                <h1>Manage Billing Group &mdash; {group.name}</h1>

                <div className="row">
                    <div className="col-md-3"><section className="powerwidget">
                        <header><h2>Billing Contact</h2></header>
                        <div className="inner-spacer">
                            <p>
                                <b>{group.contact.first_name} {group.contact.last_name}</b>{' '}
                                <small>({group.contact.email})</small>
                            </p>
                        </div>
                    </section></div>
                    <div className="col-md-3"><section className="powerwidget">
                        <header><h2>Billing Address</h2></header>
                        <div className="inner-spacer">
                            <p>
                                <b>{Address.formatFromApi(group.site)}</b><br />
                            </p>
                        </div>
                    </section></div>
                </div>

                <div className="row">
                    {payments}
                </div>
            </div>);
        }

        return <section id="accounting">
            {content}
            {this.state.groupLoading && <Loading />}
        </section>;
    },
    renderPayments: function (group) {
        if (!group) {
            return;
        }

        const token = typeof group.payment_token === 'undefined' ?
            false :
            group.payment_token;
        const tokenSelector = <TokenSelector
            allowDelete={false}
            allowNone={!group.token_required || false}
            ref="token"
            newCardHelp="Save a new card."
            selected={(token) => {
                token !== null && BillingActions.updateToken(group, token);
                this.setState({ showNew: token === null });
            }}
            token={token}
            tokens={this.state.tokens}
        />;
        const newTokenForm = this.state.showNew && <CardForm
            card={this.state.card}
            ref="newCard"
            handleUpdate={TokenActions.updateCard}
            horizontal={[3,9]}
            showNotice={false}
            showSaveCard={false}
            violations={this.state.cardErrors}
        />;

        var buttonIcon = <i className="fa fa-credit-card"></i>;
        if (this.props.working) {
            buttonIcon = <Loading message="" />;
        }

        return (<div className="col-md-7"><section className="powerwidget">
            <header><h2>Payment Methods</h2></header>
            <div className="inner-spacer form-horizontal">
                <p>Payment Term: {DateRange.format(group.term)}</p>

                {group.token_required && <div className="callout callout-warning">
                    This billing group requires a credit card on file for billing purposes.
                </div>}

                <form onSubmit={e => this.handleCardSave(e)}>
                    <div className="form-group">
                        <label className="col-md-3 control-label">Payment Method</label>
                        <div className="col-md-9">
                            {this.state.tokensLoading && <Loading />}
                            {!this.state.tokensLoading && tokenSelector}
                            <span className="help-block">
                                Select which payment method you wish to use for automatic payments
                                for any services in this group.
                            </span>
                        </div>
                    </div>

                    {newTokenForm}
                    {this.state.showNew && <div className="form-group">
                        <div className="col-md-offset-3 col-md-9">
                            <Button bsStyle="success" type="submit">
                                {buttonIcon} Save Card
                            </Button>
                        </div>
                    </div>}
                </form>
            </div>
        </section></div>);
    },
    update: function () {
        this.setState(getState(this.props.params.billingGroupId));
    }
});
module.exports = BillingGroupView;



// WEBPACK FOOTER //
// ./app/components/BillingGroup/View.js